import React from 'react';
import { TrendingUpIcon, CloudSunIcon } from 'lucide-react';
export function Header() {
  return <header className="bg-white shadow-sm" data-id="element-21">
      <div className="container mx-auto px-4 py-4" data-id="element-22">
        <div className="flex items-center justify-between" data-id="element-23">
          <div className="flex items-center space-x-2" data-id="element-24">
            <div className="h-8 w-8 text-indigo-600" data-id="element-25" />
            <h1 className="text-2xl font-bold text-gray-800" data-id="element-26">WeatherDrobe</h1>
          </div>
          <nav className="hidden md:flex space-x-6" data-id="element-27">
            <a href="#wardrobe" className="flex items-center space-x-1 text-gray-600 hover:text-indigo-600" data-id="element-28">
              <div className="h-5 w-5" data-id="element-29" />
              <span data-id="element-30">My Wardrobe</span>
            </a>
            <a href="#trends" className="flex items-center space-x-1 text-gray-600 hover:text-indigo-600" data-id="element-31">
              <TrendingUpIcon className="h-5 w-5" data-id="element-32" />
              <span data-id="element-33">Trends</span>
            </a>
            <a href="#weather" className="flex items-center space-x-1 text-gray-600 hover:text-indigo-600" data-id="element-34">
              <CloudSunIcon className="h-5 w-5" data-id="element-35" />
              <span data-id="element-36">Weather</span>
            </a>
          </nav>
          <button className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition" data-id="element-37">
            Sign In
          </button>
        </div>
      </div>
    </header>;
}